import { createContext, useContext, useState, useEffect } from "react";
import { translations } from "@/lib/translations";

const LanguageContext = createContext(null);

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState(() => {
    if (typeof window !== "undefined") {
      const isEnglishDomain = window.location.hostname.includes("getholidaygenie.com");
      const storageKey = isEnglishDomain ? "vg_lang_genie" : "vg_lang_genio";
      const savedLang = localStorage.getItem(storageKey);
      if (savedLang) return savedLang;
      return isEnglishDomain ? "en" : "it";
    }
    return "it";
  });

  useEffect(() => {
    if (typeof window !== "undefined") {
      const isEnglishDomain = window.location.hostname.includes("getholidaygenie.com");
      const storageKey = isEnglishDomain ? "vg_lang_genie" : "vg_lang_genio";
      localStorage.setItem(storageKey, lang);
      document.documentElement.lang = lang;
    }
  }, [lang]);

  const t = translations[lang] || translations["it"];
  const toggle = () => setLang((prev) => (prev === "it" ? "en" : "it"));

  return (
    <LanguageContext.Provider value={{ lang, setLang, toggle, t }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLang = () => {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error("useLang must be used within LanguageProvider");
  return ctx;
};
